
import 'bootstrap/dist/css/bootstrap.min.css';
import '@aws-amplify/ui-react/styles.css';
import '../../App.css'
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Image } from '@aws-amplify/ui-react';
import 'material-symbols';
import { forwardRef } from 'react';


export const AppNavBar = ({ }) => {
    const CustomToggle = forwardRef(({ children, onClick }, ref) => (
        <div ref={ref}
            onClick={(e) => {
                e.preventDefault()
                onClick(e)
            }}>
            {children}
        </div>
    ))
    return (
        <Navbar sticky="top" expand="lg" className="bg-body-tertiary w-100">
            <Container fluid={true}>
                <Navbar.Brand href="/">
                    <div className='d-flex align-item-center'>
                        <Image src="/logo192.png" style={{ maxHeight: '2.5rem' }}></Image>
                        <span className='brand'>Liftolog</span>
                    </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
                        <Nav.Link as={Link} to="/exercises">Exercises</Nav.Link>
                        <Nav.Link as={Link} to="/catalog">Catalog</Nav.Link>
                    </Nav>


                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}